export default "__VITE_ASSET__Dyb$PqEb__"